import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import StoreRoundedIcon from '@mui/icons-material/StoreRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import Diversity3RoundedIcon from '@mui/icons-material/Diversity3Rounded';
import WalletRoundedIcon from '@mui/icons-material/WalletRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import AgricultureRoundedIcon from '@mui/icons-material/AgricultureRounded';

type ObjectType =
      'contact'
    | 'contacts'
    | 'workplan'
    | 'workplans'
    | 'business'
    | 'businesses'
    | 'property'
    | 'properties'
    | 'event'
    | 'events'
    | 'opportunity'
    | 'opportunities'
    | 'donation'
    | 'donations'
;

type NonStandardObjectTypes =
      'home'
    | 'reports'
    | 'settings'
;

export function iconForObjectType(objectType:ObjectType|NonStandardObjectTypes|null, displayFallback?:boolean) {
    switch(objectType) {
        case 'home':
                return HomeRoundedIcon;
        case 'contact':
        case 'contacts':
            return PeopleRoundedIcon;
        case 'workplan':
        case 'workplans':
            return ChecklistRoundedIcon;
        case 'business':
        case 'businesses':
            return StoreRoundedIcon;
        case 'property':
        case 'properties':
            return ApartmentRoundedIcon;
        case 'event':
        case 'events':
            return CalendarMonthRoundedIcon;
        case 'opportunity':
        case 'opportunities':
            return Diversity3RoundedIcon;
        case 'donation':
        case 'donations':
            return WalletRoundedIcon;
        case 'reports':
            return QueryStatsRoundedIcon;
        case 'settings':
            return ConstructionRoundedIcon;
    }

    // return something silly when there's no match
    return displayFallback ? AgricultureRoundedIcon : null;
}
